import React from "react";
// Components
import HorizontalCard from "../generic/VerticalCard";
// Styled
import styled from "styled-components";
// React Router
import { useHistory, useParams } from "react-router-dom";

const CardAddGrupoTrabajo = styled(HorizontalCard)`
    background-color: #f4fafd;
    :hover {
        box-shadow: 0 0px 6px #2a599f !important;
    }
`;

const GruposTrabajoTarjetaAdd = ({ ...props }) => {


    let { id_p } = useParams()
    let history = useHistory();
    let provinciaId = id_p ? id_p : '14'

    let defaultImg = `/images/provincias/${provinciaId}.png`;
    let img = `${process.env.REACT_APP_API_URL}/provincias/${provinciaId}/`;
    let imgOnError = defaultImg;
    let title = `Añadir un nuevo Equipo/Comisión`;

    return (

        <CardAddGrupoTrabajo {...props} onClick={() => {
            history.push(`gruposTrabajo/add`);
        }} cardImage={img} title={title} imgOnError={imgOnError} {...props}></CardAddGrupoTrabajo>
    );
};

export default GruposTrabajoTarjetaAdd;
